import AudioManager from './AudioManager'
export default AudioManager
